import { decodeValueForHtmlAttr } from '../../helpers/mini/keepJSONInAttr';
import { AlanButton } from './../../model/AlanButton';

export function processClickByButtonInChat(clickedEl, btnInstance: AlanButton, sendTextCall) {
    if (clickedEl.classList.contains('alan-chat__chat-btn')) {
        const btnLabel = clickedEl.getAttribute('data-alan-button-label');
        const btnText = clickedEl.getAttribute('data-alan-button-send-text');
        const vsAttr = clickedEl.getAttribute('data-alan-button-set-visual-state');
        const callPropjectApiMethodAttr = clickedEl.getAttribute('data-alan-button-call-project-api');
        const callPropjectApiDataAttr = clickedEl.getAttribute('data-alan-button-call-project-api-param');

        if (vsAttr) {
            let data = null;
            try {
                data = decodeValueForHtmlAttr(vsAttr);
            } catch (err) {
                console.log('Alan: unable to parse params for calling setVisualState');
            }

            if (data) {
                btnInstance.setVisualState(data);
                return;
            }

        }

        if (callPropjectApiMethodAttr) {
            const method = callPropjectApiMethodAttr;
            let data = null;
            try {
                data = decodeValueForHtmlAttr(callPropjectApiDataAttr);
            } catch (err) {
                console.log('Alan: unable to parse params for calling project api method');
            }

            if (method) {
                btnInstance.callProjectApi(method, data, () => { });
                return;
            }
        }

        if (btnText || btnLabel) {
            sendTextCall(btnText || btnLabel);
            return;
        }
    }
}